import {
  handleResp,
  handleBlobResp,
  getURLWithQueryParams,
  getDefaultHeaders,
  extendFetchOptions,
} from "./utils";
import type {
  WrappedCashifyFunction,
  GenericResponse,
  CommonResponse,
  WrappedCashifyPageableQuery,
} from "./utils";
import type {
  ApplicationDetailResponse,
  ApplicationDTO,
  ApplicationSearchCriteria,
} from "./fubon-credit-application-types";

export interface ApplicationService {
  listApplication: ReturnType<typeof listApplication>;
  getApplicationDetail: ReturnType<typeof getApplicationDetail>;
  cancelApplication: ReturnType<typeof cancelApplication>;
  getApplicationDocument: ReturnType<typeof getApplicationDocument>;
}

export const listApplication: WrappedCashifyPageableQuery<
  ApplicationSearchCriteria,
  ApplicationDTO
> = ({ urlPrefix, options }) => {
  return async (queryParams) => {
    let url = getURLWithQueryParams(
      `${urlPrefix}/api/v1/fuboncredit/loan/application`,
      queryParams
    );
    let opts = extendFetchOptions(
      {
        method: "GET",
        headers: getDefaultHeaders(),
      },
      options
    );
    return fetch(url, opts).then((resp) => handleResp(resp));
  };
};

export const getApplicationDetail: WrappedCashifyFunction<
  { id: string },
  GenericResponse<ApplicationDetailResponse>
> = ({ urlPrefix, options }) => {
  return async ({ id }) => {
    let url = `${urlPrefix}/api/v1/fuboncredit/loan/application/${id}`;
    let opts = extendFetchOptions(
      {
        method: "GET",
        headers: getDefaultHeaders(),
      },
      options
    );
    return fetch(url, opts).then((resp) => handleResp(resp));
  };
};

export const cancelApplication: WrappedCashifyFunction<
  { userId: string; applicationId: string },
  CommonResponse
> = ({ urlPrefix, options }) => {
  return async ({ userId, applicationId }) => {
    let url = `${urlPrefix}/api/v1/fuboncredit/loan/application/application/${applicationId}/cancellation`;
    let opts = extendFetchOptions(
      {
        method: "POST",
        headers: {
          ...getDefaultHeaders(),
          "x-user-id": userId,
          "Content-Type": "application/json",
        },
      },
      options
    );
    return fetch(url, opts).then((resp) => handleResp(resp));
  };
};

export const getApplicationDocument: WrappedCashifyFunction<
  { id: string; documentId: string },
  Blob
> = ({ urlPrefix, options }) => {
  return async ({ id, documentId }) => {
    let url = `${urlPrefix}/api/v1/fuboncredit/loan/application/${id}/document/${documentId}`;
    let opts = extendFetchOptions(
      {
        method: "GET",
        headers: {
          Accept: "application/octet-stream",
        },
      },
      options
    );
    return fetch(url, opts).then((resp) => handleBlobResp(resp));
  };
};
